// extracted by mini-css-extract-plugin
module.exports = {"recipe-image":"recipe_recipe-image__2Xnq3","recipe":"recipe_recipe__2cR-9","corner":"recipe_corner__1zFim"};